
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sources/mysql",
      function () {
        return require("private-next-pages/sources/mysql.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sources/mysql"])
      });
    }
  